import {computed, inject, type ComputedRef, type Ref} from 'vue';
import {useUserStore} from '@/ts/store/user-store';
import {useRoute} from 'vue-router';
import type {VoucherCodeQuery} from '@/ts/types/component/sign-up-type';
import {BRANDED_PARTNERS, organizationMatchesPartner} from '@/ts/composables/pure/use-partner-matching';

/**
 * Resolves which partner's branding applies, from the sign-up URL code,
 * the validated voucher's organization, or the logged-in user's organization
 */
export function usePartnerBranding(): {partner: ComputedRef<VoucherCodeQuery | null>} {
  const userStore = useUserStore();
  const route = useRoute();
  const voucherOrganizationName = inject<Ref<string | null> | null>('voucherOrganizationName', null);

  const partner = computed((): VoucherCodeQuery | null => {
    const organizationNames = [
      userStore.userData?.organization?.name,
      voucherOrganizationName?.value,
    ];
    const matches = (code: VoucherCodeQuery): boolean =>
      route.query.code === code
      || organizationNames.some((name) => organizationMatchesPartner(name, code));
    return BRANDED_PARTNERS.find(matches) ?? null;
  });

  return {
    partner,
  };
}
